@use 'sass:map';
@use '@helsenorge/designsystem-react/scss/spacers' as spacers;
@use '@helsenorge/designsystem-react/scss/palette' as palette;
@import '@helsenorge/designsystem-react/scss/breakpoints';
@import '@helsenorge/designsystem-react/scss/grid';

.linklistblock {
  @include make-row(0);

  &__content {
    @include make-col-ready;
    @include make-col(12);

    padding: spacers.getSpacer(l) spacers.getSpacer(s);

    @media (min-width: map.get($grid-breakpoints, lg)) {
      padding-top: spacers.getSpacer(xl);
      padding-bottom: spacers.getSpacer(xl);
    }

    &--grid {
      @media (min-width: map.get($grid-breakpoints, md)) {
        @include make-col(10);
        @include make-col-offset(1);

        padding-left: 0;
        padding-right: 0;
      }

      @media (min-width: map.get($grid-breakpoints, lg)) {
        @include make-col(8);
        @include make-col-offset(2);

        padding-top: spacers.getSpacer(xl);
        padding-bottom: spacers.getSpacer(xl);
      }
    }

    $colors: 'blueberry', 'cherry', 'neutral';

    @each $color in $colors {
      &--#{$color} {
        background-color: map.get(palette.$palette-map, #{$color}50);
      }
    }

    @media print {
      border: 1px solid palette.$black;
      padding: spacers.getSpacer(m);
    }
  }

  &__additional-link-list {
    margin-top: spacers.getSpacer(l);

    @media (min-width: map.get($grid-breakpoints, lg)) {
      margin-top: spacers.getSpacer(xl);
    }
  }
}
